import type { NavItem } from '../types/navigation';

// Add more services to the `children` array below, e.g.
// { label: 'Lawn Mowing', href: '/lawn-mowing' }
export const navItems: NavItem[] = [
  { label: 'Home', href: '/' },
  {
    label: 'Services',
    href: '/#services',
    children: [{ label: 'Christmas Lights', href: '/christmas-lights' }],
  },
  { label: 'Reviews', href: '/#reviews' },
  { label: 'About Us', href: '/#about' },
  { label: 'Contact', href: '/#contact' },
];
